import { createClient, type QueryParams } from "next-sanity";
import { apiVersion, dataset, projectId } from "./env";

export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false, // Set to false if statically generating pages, using ISR or tag-based revalidation
  fetch: {
    next: { revalidate: 300 },
  },
});

const clientCdn = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: true,
});

export async function sanityFetch<const QueryString extends string>({
  query,
  params = {},
}: {
  query: QueryString;
  params?: QueryParams;
  revalidate?: number | false;
}) {
  return client.fetch(query, params, {
    next: {
      revalidate: 300,
    },
  });
}

export async function sanityFetchCdn<const QueryString extends string>({
  query,
  params = {},
  revalidate = false,
}: {
  query: QueryString;
  params?: QueryParams;
  revalidate?: number | false;
}) {
  return clientCdn.fetch(query, params, {
    next: { revalidate },
  });
}
